import React from 'react';
import { TOPBAR_CONFIG } from '../../config/topbarConfig';

// Generic SVG Icon Component - Memoized for performance
export const SvgIcon = React.memo(({ 
  iconConfig, 
  className = '', 
  fill = 'currentColor', 
  stroke = 'none',
  ...props 
}) => {
  const {
    viewBox,
    path,
    size,
    strokeWidth,
    strokeLinecap,
    strokeLinejoin,
    fillRule,
    clipRule
  } = iconConfig;

  return (
    <svg 
      className={`${size} ${className}`}
      fill={stroke === 'none' ? fill : 'none'}
      stroke={stroke}
      viewBox={viewBox}
      strokeWidth={strokeWidth}
      strokeLinecap={strokeLinecap}
      strokeLinejoin={strokeLinejoin}
      role="img"
      aria-hidden="true"
      {...props}
    >
      <path 
        fillRule={fillRule} 
        clipRule={clipRule} 
        d={path} 
      />
    </svg>
  );
});

SvgIcon.displayName = 'SvgIcon';

// Specific Icon Components - All memoized for performance
export const SearchIcon = React.memo(({ className = '', ...props }) => (
  <SvgIcon 
    iconConfig={TOPBAR_CONFIG.ICONS.search}
    className={className}
    {...props}
  />
));

SearchIcon.displayName = 'SearchIcon';

export const SearchIconMobile = React.memo(({ className = '', ...props }) => (
  <SvgIcon 
    iconConfig={TOPBAR_CONFIG.ICONS.searchMobile}
    className={className}
    {...props}
  />
));

SearchIconMobile.displayName = 'SearchIconMobile';

export const LocationIcon = React.memo(({ className = '', ...props }) => (
  <SvgIcon 
    iconConfig={TOPBAR_CONFIG.ICONS.location}
    className={className}
    {...props}
  />
));

LocationIcon.displayName = 'LocationIcon';

export const ChevronDownIcon = React.memo(({ className = '', ...props }) => (
  <SvgIcon 
    iconConfig={TOPBAR_CONFIG.ICONS.chevronDown}
    className={className}
    {...props}
  />
));

ChevronDownIcon.displayName = 'ChevronDownIcon';

export const CartIcon = React.memo(({ className = '', ...props }) => (
  <SvgIcon 
    iconConfig={TOPBAR_CONFIG.ICONS.cart}
    className={className}
    stroke="currentColor"
    {...props}
  />
));

CartIcon.displayName = 'CartIcon';

export const UserIcon = React.memo(({ className = '', ...props }) => (
  <SvgIcon 
    iconConfig={TOPBAR_CONFIG.ICONS.user}
    className={className}
    stroke="currentColor"
    {...props}
  />
));

UserIcon.displayName = 'UserIcon';
